import { DecimalPipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Subscription, Observable } from "rxjs";
import { AddressModel } from "src/app/core/models/address.model";
import { ContactBaseModel } from "src/app/core/models/contact/contact-base.model";
import { ContactModel } from "src/app/core/models/contact/contact.model";
import { ErrorModel } from "src/app/core/models/error.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { ContactListService } from "src/app/core/services/list-services/contact-list.service";
import { OpenModalService } from "src/app/core/services/modal-services/open-modal.service";
import { PdfViewerModalService } from "src/app/core/services/modal-services/pdf-viewer-modal.service";
import { MyfileApiService } from "src/app/core/services/myfile-api.service";
import { ToasterNotificationService } from "src/app/core/services/toaster-notification.service";
import Swal from "sweetalert2";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { ContactListSortBy } from "src/app/core/enums/sort-by-options/contact-list-sort-enum";
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { SortByTypeEnum } from "src/app/core/enums/list-layout/sort-type-enum";
import { ExportType } from "src/app/core/models/reporting/export-config-model";
import { TaskModel } from "src/app/core/models/task/task.model";
import { TaskModalService } from "src/app/core/services/modal-services/task-modal.service";
import { ListLayoutExtendableComponent } from "../list-layout/list-layout-extendable/list-layout-extendable.component";

import { EmitSortModel } from "../../../core/models/table/emit-sort.model";
import { ListFilterModel } from "../../../core/models/table/list-filter.model";
import { ServiceData } from "../../../core/models/table/service-data.model";
import { TableActionsModel } from "../../../core/models/table/table-action.model";
import { TableContactFilter } from "./configs/table-contact-filter-config-enum";
import { ContactListTableConfig } from "./configs/table-contact-list.config";
import { TableConfigurationModel } from "../../../core/models/table/table-configuration.model";
import { TableConfigService } from "src/app/core/services/table-config.service";
import { GlobalComponent } from "src/app/global-component";


@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss'],
  providers: [ContactListService, DecimalPipe, AuthMyfileService],
})
export class ContactListComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();

  contactIsEnabledAvailableOptions = [
    { value: undefined, selectedText: $localize`:@@:Select Status`, dropdownText: $localize`:@@:Select Status`, default: true },
    { value: true, selectedText: $localize`:@@Contact_Status_Enabled:Enabled`, icon: "bx bx-check-circle" },
    { value: false, selectedText: $localize`:@@Contact_Status_Disabled:Disabled`, icon: "bx bx-error-alt" },
  ]

  contactIsEnabledSelectedOption: boolean | undefined;

  override listItemsObservable!: Observable<ContactBaseModel[]>;

  protected override searchPlaceHolderText: string = "Search for contact number, name, company name, or email";

  sortBy: ContactListSortBy = ContactListSortBy.None;

  viewModel: boolean = false;

  model: ContactModel = new ContactModel();

  serviceData: ServiceData = new ServiceData();

  //Security Operations of the current User
  securityPermissionContactCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountCreate);
  securityPermissionContactDelete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountDelete);
  securityPermissionContactManagement: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement);
  securityPermissionContactUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement);

  configItemsObservable!: Observable<TableConfigurationModel[]>;

  constructor(
    protected taskModalService: TaskModalService,
    protected contactListService: ContactListService,
    protected tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  @Input() public disabled: boolean = false;

  ngOnInit(): void {

    this.tableConfig = new ContactListTableConfig();

    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));
        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.contactListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.contactListService.resultItems$;
    this.total = this.contactListService.total$;
    this.isLoading = this.contactListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((contactModel: ContactBaseModel) => {
        this.getEntityPhoto(contactModel, EntityTypeEnum.Account);
      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.contactListService.totalRecords;
      this.serviceData.pageSize = this.contactListService.pageSize;
      this.serviceData.pageIndex = this.contactListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);
  }

  ngOnDestroy() {
    this.clearSearch(this.contactListService);
    this.clearSearch(this.tableConfigService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  deleteData(modelId: string) {
    this.submitted = true;
    Swal.fire({
      title: $localize`:@@:Delete Contact`,
      text: $localize`:@@:Are you sure you want to delete this Contact?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Ok`,
      cancelButtonText: $localize`:@@:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        this.myFileApiService.deleteContact(modelId).subscribe((result: ErrorModel | boolean | undefined) => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@: Contact has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          this.serviceSort(this.contactListService, '', '');
          this.submitted = false;
        });
      } else {
        this.submitted = false;
      }
    });

  }

  contactIsEnabledFilter() {
    switch (this.contactIsEnabledSelectedOption) {
      case true:
        this.contactListService.isEnabled = true;
        break;
      case false:
        this.contactListService.isEnabled = false;
        break;
      default:
        this.contactListService.isEnabled = undefined;
        break;
    }
  }

  openModalNew() {
    this.openModalService.newContactModal(this.contactListService);
  }

  openModalEdit(contactId: string | undefined, $event: MouseEvent) {
    if (contactId == undefined) {
      this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
      return;
    }
    $event.stopPropagation();
    this.openModalService.editContactModal(this.contactListService, contactId, undefined, undefined);
  }

  sideProfileView(modelId: string) {
    this.viewModel = true;
    this.isLoadingVal = true;
    var sub: Subscription = this.myFileApiService.getContact(modelId).subscribe((contact: ContactModel) => {
      if (contact) {
        this.model = contact;
        this.legacyContactInfoCheckAndSet();
      }
      this.isLoadingVal = false;
      sub.unsubscribe();
    });
  }

  legacyContactInfoCheckAndSet() {
    this.getEntityPhoto(this.model, EntityTypeEnum.Account)
    if (this.model.address == null || this.model.address == undefined) {
      this.model.address = new AddressModel();  //used for legacy contacts. 
    }
  }

  //** new simpler sort function for futher lists with new layout component */
  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.contactListService, '', '');
    } else {
      this.serviceSort(this.contactListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  //** Old sort function still in place for now since the extended lists of contact-picklist and contact-list-dropdown still use old layout and not new dynamic layout */
  sort(passedSortBy: ContactListSortBy) {
    this.sortBy = passedSortBy;
    switch (passedSortBy) {

      case ContactListSortBy.NameAsc:
        this.serviceSort(this.contactListService, 'firstName', 'asc');
        break;

      case ContactListSortBy.NameDesc:
        this.serviceSort(this.contactListService, 'firstName', 'desc');
        break;

      case ContactListSortBy.NumAsc:
        this.serviceSort(this.contactListService, 'number', 'asc');
        break;

      case ContactListSortBy.NumDesc:
        this.serviceSort(this.contactListService, 'number', 'desc');
        break;
      case ContactListSortBy.CompanyAsc:
        this.serviceSort(this.contactListService, 'companyName', 'asc');
        break;

      case ContactListSortBy.CompanyDesc:
        this.serviceSort(this.contactListService, 'companyName', 'desc');
        break;

      case ContactListSortBy.EmailAsc:
        this.serviceSort(this.contactListService, 'email', 'asc');
        break;

      case ContactListSortBy.EmailDesc:
        this.serviceSort(this.contactListService, 'email', 'desc');
        break;
      case ContactListSortBy.PhoneAsc:
        this.serviceSort(this.contactListService, 'phoneNumber', 'asc');
        break;

      case ContactListSortBy.PhoneDesc:
        this.serviceSort(this.contactListService, 'phoneNumber', 'desc');
        break;

      default:
        this.serviceSort(this.contactListService, '', '');
        break;
    }
  }

  trackByFn(item: any) {
    return item.id;
  }

  deleteMultipleContacts() {
    var checkboxes: any = document.getElementsByName('checkAll');
    var result
    var checkedVal: any[] = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        result = checkboxes[i].value;
        checkedVal.push(result);
      }
    }
    if (checkedVal.length > 1) {
      Swal.fire({
        title: $localize`:@@:Delete Multiple Contacts`,
        text: $localize`:@@:Are you sure you want to delete these contacts?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Ok`,
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        cancelButtonText: $localize`:@@:Cancel`,
      }).then(result => {
        if (result.isConfirmed) {
          for (var i = 0; i < checkedVal.length; i++) {
            var reloadList: number = checkedVal.length;

            this.myFileApiService.deleteContact(checkedVal[i]).subscribe((result: ErrorModel | boolean | undefined) => {
              reloadList = reloadList - 1;
              if (reloadList == 0) {
                this.serviceSort(this.contactListService, '', '');
              }
              if (result) {
                this.toasterNotificationService.showSuccess($localize`:@@: Contact has been deleted.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
              }
            });
          }
        }
      });
    } else if (checkedVal.length == 1) {
      this.deleteData(checkedVal[0]);
    }
    else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select a Contact',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
    this.checkedValGet = checkedVal;
  }

  buttonActionSelected(buttonAction: any) {
    var action = buttonAction;

    if (buttonAction.buttonId !== undefined) {
      action = buttonAction.buttonId
    }

    switch (action) {
      case ButtonIdEnum.CreateNew:
        this.openModalNew()
        break;
      case `${ButtonIdEnum.ExportCSV}`:
        this.exportTo(ExportType.Csv, this.contactListService.searchModel, 'Contacts', 'Accounts',this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportExcel}`:
        this.exportTo(ExportType.Excel, this.contactListService.searchModel, 'Contacts', 'Accounts',this.tableConfig)
        break;
      case `${ButtonIdEnum.ExportTenant}`:
        if (this.checkedValGet == undefined || this.checkedValGet.length == 0) {
          Swal.fire({
            icon: 'warning',
            text: 'Please select the record(s) to Export',
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            confirmButtonColor: '#299cdb',
          });
        } else {
          this.myFileApiService.newTaskContactExport().subscribe((newTaskModel: TaskModel | undefined) => {
            if (newTaskModel !== undefined) {
              this.taskModalService.openModal(newTaskModel, this.checkedValGet, "Export");
            }
          });

        }
        break;
      case ButtonIdEnum.Delete:
        this.deleteMultipleContacts();
        break;
    }
  }

  rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.serviceData.loadingValue = true;
        this.openModalService.editContactModal(this.contactListService, rowAction.model.id, undefined, undefined);
        break;
      case ActionIdEnum.Delete:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.serviceData.loadingValue = true;
          this.deleteData(rowAction.model.id)
        }
        break;
      case ActionIdEnum.OpenModal:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.serviceData.loadingValue = true;
        this.openModalService.openContactModal(rowAction.model, this.contactListService, undefined, undefined);
        break;
      case ActionIdEnum.View:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.sideProfileView(rowAction.model.id)
        }
        break;
    }
  }

  filterSelected(filterSelected: ListFilterModel) {
    switch (filterSelected.label) {
      case TableContactFilter.ContactStatusFilter:
        if (filterSelected.selectedOption !== undefined) {
          this.contactIsEnabledSelectedOption = Boolean(filterSelected.selectedOption);
        } else {
          this.contactIsEnabledSelectedOption = undefined;
        }
        this.contactIsEnabledFilter();
        break;
    }
  }
}
